import React, { useContext, useState, useEffect } from 'react';
import FindingDetail from '../Inspections/Findings/FindingDetail';
import { InspectionContext } from '../../contexts/InspectionContext';
import SuccessNotification from '../Shared/SuccessNotification/SuccessNotification';
import { useHistory } from 'react-router-dom'; //

const GuestFindingDetails = () => {

  const history = useHistory();
  const inspectionContext = useContext(InspectionContext);
  const [showSuccessNotification, setShowSuccessNotification] = useState<boolean>(false);
  const [timeoutId, setTimeoutId] = useState<number>(-1);
  const inspectionId = inspectionContext.inspection.id;

  const listingView = () => {
    inspectionContext.setSelectedFindings([]);
  };

  const showSuccessAnimation = () => {
    // show save animation
    const newTimeoutId = window.setTimeout(() => {
      setShowSuccessNotification(false);
    }, 2000);

    setShowSuccessNotification(true);
    setTimeoutId(newTimeoutId);
  };

  useEffect(() => {
    return () => {
      if (timeoutId > -1) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <>
      <FindingDetail
        onBackClick={listingView}
        onSubmit={showSuccessAnimation}
        onDelete={() => {
          // setSelectedFinding(null);
          history.push(`/guest/inspection/${inspectionId}/findings`);
        }}
      />
      <div className='guest-space-bottom'></div>
      <SuccessNotification show={showSuccessNotification} />
    </>
  )
}

export default GuestFindingDetails